import React from 'react';
import classNames from 'classnames';
import Immutable from 'immutable';

import { Breadcrumbs, Paragraph, Taxonomy } from '@uncinc/react-drupal-core';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import {
  WysiwygField,
  Share,
  Hero,
} from '../../../components';

import useLoggedInStatus from '../../../hooks/useLoggedInstatus';
import NewsletterBlock from '../../../components/NewsletterBlock';
import MemberWall from '../../../components/MemberWall';

import './style.scss';

const NodeBasicPage = ({ entity, className }) => {
  const { isLoggedIn } = useLoggedInStatus();
  const title = entity.getIn(['title', 0, 'value']);
  const theme = entity.getIn(['field_theme', 0, 'entity']);
  const body = entity.getIn(['body', 0, 'processed'], '');
  const subtitle = entity.getIn(['field_subtitle', 0, 'value']);
  const image = entity.getIn(['field_media_image', 0], Immutable.Map());
  const isMemberOnlyContent = entity.getIn(['field_member_only_content', 0, 'value'], false);
  const classes = classNames(className, 'BasicPage', {
    'BasicPage--hero-image': (image.size > 0),
  });

  const showMemberWall = !isLoggedIn && isMemberOnlyContent;

  return (
    <article typeof="schema:WebPage" className={classes}>
      <div className="BasicPage__hero-wrapper">
        <Hero
          image={image}
        />
      </div>

      <Container>
        <div className="BasicPage__content-wrapper row">
          <div className="col-12 col-lg-10 col-sm-12 offset-lg-1">
            <div className="BasicPage__content" id="main">
              <Breadcrumbs includeCurrent />
              <h1 property="schema:name" className="BasicPage__title node--page--title">
                {title}
              </h1>
              {subtitle && (
                <div className="BasicPage__subtitle">
                  {subtitle}
                </div>
              )}
              {body ? (
                <WysiwygField
                  property="schema:text"
                  className="BasicPage__body subheading2"
                  html={body}
                />
              ) : null}
            </div>
          </div>
        </div>
      </Container>

      <div className="NodeContentWrapper">
        {entity.get('field_paragraphs') ? (
          <div className="NodeBasicPage__paragraphs">
            {entity.get('field_paragraphs', Immutable.List()).map((paragraph) => {
              const id = paragraph.get('target_id');
              const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);
              return (
                <Paragraph
                  key={`paragraph:${id}:${language}`}
                  id={id}
                  entity={paragraph.get('entity')}
                />
              );
            })}
          </div>
        ) : null}

        {entity.getIn(['field_paragraph_feedback', 0]) && (
          <div className="NodeArticleDetail__feedback">
            {
              entity.getIn(['field_paragraph_feedback']).map((item, index) => {
                const paragraphId = item.get('target_id');
                const paragraph = item.getIn(['entity']);

                return (
                  <Paragraph key={paragraphId} entity={paragraph} id={paragraphId} />
                );
              })
            }
          </div>
        )}

        {theme && (
          <Container>
            <div className="row">
              <div className="col-12">
                <Taxonomy
                  id={theme.getIn(['tid', 0, 'value'])}
                  entity={theme}
                  viewMode="card"
                />
              </div>
            </div>
          </Container>
        )}

        <Container>
          <div className="row">
            <div className="col-12 col-lg-8 offset-lg-2">
              <Share pageTitle={entity.getIn(['title', 0, 'value'], '')} />
            </div>
          </div>
        </Container>
      </div>

      {/* Member wall. */}
      {showMemberWall && (
        <MemberWall />
      )}

      {/* Newsletter subscription block */}
      <NewsletterBlock />
    </article>
  );
};

export default NodeBasicPage;
